module.exports = __webpack_public_path__ + "img/ccb.6d20c178.jpeg";